import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const masterDataProvinceListService = (
  params: Types.MasterDataProvinceListRequest
) =>
  RestAPIClient.call<Types.MasterDataProvinceListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${String(params?.countryId)}`,
    config: {
      requireAuthentication: true,
      params: omit(params, ["countryId"]),
    },
  });

export const masterDataProvinceListShortService = (
  params: Types.MasterDataProvinceListRequest
) =>
  RestAPIClient.call<Types.MasterDataProvinceListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List}/${String(params?.countryId)}/short`,
    config: {
      requireAuthentication: true,
      params: omit(params, ["countryId"]),
    },
  });
